import React from 'react';
import {styled} from '@mui/material/styles';
import {Box, Typography, useTheme} from '@mui/material';
import {Close} from '@mui/icons-material';
import {matchPath, useLocation, useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '@hooks';
import {commonRedux} from '@store';
import {useTranslation} from 'react-i18next';

const StyledTab = styled(Box)(({theme}) => ({
  background: theme.palette.primary.main,
  padding: '0 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: 8,
  borderRight: '1px solid white',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '&:hover': {
    '.icon-button': {
      opacity: 1,
    },
  },
  '&:first-of-type': {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  '&:last-of-type': {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
  },
}));

const StyledCloseIconButton = styled(Box)(({theme}) => ({
  background: theme.palette.primary.main,
  padding: 7,
  opacity: 0,
  transition: '0.3s ease all',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Tab = ({item}: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const {pathname} = useLocation();
  const isActivePath = (path: any) => (path ? !!matchPath({path, end: false}, pathname) : false);

  return (
    <StyledTab
      sx={{
        opacity: isActivePath(item.path) ? 0.8 : 1,
      }}
      onClick={() => {
        navigate(item?.path);
      }}
    >
      <Typography sx={{color: 'white', fontSize: 14, mt: 0.1}}>{t(item?.title)}</Typography>
      <StyledCloseIconButton className="icon-button" onClick={() => {}}>
        <Close
          onClick={e => {
            e.stopPropagation();
            dispatch(commonRedux.setPageTab({path: item?.path}));
          }}
          fontSize="small"
          sx={{ml: 2, color: theme.palette.common.white}}
        />
      </StyledCloseIconButton>
    </StyledTab>
  );
};

const PageUserTabs = () => {
  const pageTabs = useAppSelector(state => state.common.pageTabs);
  return (
    <Box sx={{display: 'flex', flex: 999, overflow: 'scroll', width: '100%'}}>
      {pageTabs?.map((tab: any, i: number) => (
        <Tab key={i} item={tab} />
      ))}
    </Box>
  );
};

export default PageUserTabs;
